import React, { useEffect, useRef, useState } from "react";
import { Button, Col, Container, Image } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { auth, db } from "../firebase";
import { useAuthState } from "react-firebase-hooks/auth";
import { useCollection } from "react-firebase-hooks/firestore";
import firebase from "firebase";
import TimeAgo from "timeago-react";

import "./ChatScreen.css";
import Message from "./Message";

function ChatScreen() {
  let { id, mail } = useParams();
  const [user] = useAuthState(auth);
  const endOfMessageRef = useRef(null);
  const [messages, setMessages] = useState([]);
  const [inputMessage, setInputMessage] = useState("");
  const UsersEmail = [];
  // var recipientEmail = "";
  const [recipientSnapshot] = useCollection(
    db.collection("users").where("email", "==", mail)
  );

  const scrollToBotton = () => {
    endOfMessageRef.current.scrollIntoView({
      behavior: "smooth",
    });
  };
  // scrollToBotton();
  const sendMessage = (e) => {
    e.preventDefault();
    db.collection("users").doc(user.uid).set(
      {
        lastSeen: firebase.firestore.FieldValue.serverTimestamp(),
      },
      { merge: true }
    );

    db.collection("chats").doc(id).collection("messages").add({
      timestamp: firebase.firestore.FieldValue.serverTimestamp(),
      message: inputMessage,
      user: user.email,
      photoURL: user.photoURL,
    });

    scrollToBotton();
    setInputMessage("");
  };

  const userChatRef = db.collection("chats").doc(id);

  userChatRef.get().then((doc) => {
    if (doc.exists) {
      doc.data().users.map((user) => UsersEmail.push(user));
    }
  });

  const recipient = recipientSnapshot?.docs?.[0].data();

  useEffect(() => {
    const unsubscribe = db
      .collection("chats")
      .doc(id)
      .collection("messages")
      .orderBy("timestamp", "asc")
      .onSnapshot((snapshot) =>
        setMessages(
          snapshot.docs.map((doc) => ({
            id: doc.id,
            data: doc.data(),
          }))
        )
      );
    return unsubscribe;
  }, [id]);

  //   console.log(messages);

  return (
    <Container>
      <div className="chat_header">
        {recipient ? (
          <Col xs={6} md={4} className="chat_profile_img">
            <Image
              className="image-avatar"
              src={recipient?.photoURL}
              roundedCircle
            />
            <h3 className="chat_profile_user_name">{recipient?.displayName}</h3>
          </Col>
        ) : (
          <Col xs={6} md={4} className="chat_profile_img">
            <Image className="image-avatar" src={mail[0]} roundedCircle />
            <h3 className="chat_profile_user_name">{recipient?.displayName}</h3>
          </Col>
        )}
        {/* <h4>last seen </h4> */}
        {recipientSnapshot ? (
          <h4>
            Last active :{" "}
            {recipient?.lastSeen?.toDate() ? (
              <TimeAgo datetime={recipient?.lastSeen?.toDate()} />
            ) : (
              "Unavailable"
            )}
          </h4>
        ) : (
          <h4>Loading Last active ...</h4>
        )}
      </div>
      <Container className="message_container">
        {messages.map((message) => (
          <Message key={message.id} id={message.id} data={message.data} />
        ))}
        <div ref={endOfMessageRef}></div>
      </Container>
      <Container className="input_container">
        <form onSubmit={sendMessage}>
          <input
            type="text"
            value={inputMessage}
            onChange={(e) => setInputMessage(e.target.value)}
          />
          <Button disabled={!inputMessage}>Send</Button>
        </form>
      </Container>
    </Container>
  );
}

export default ChatScreen;
